import React from 'react';
import { AppBar, Toolbar, Typography, Button, Box, Avatar, Chip } from '@mui/material';
import { Dashboard as DashboardIcon, AccountBalance as WithdrawIcon, Cable as IntegrationsIcon } from '@mui/icons-material';
import { NavLink, useLocation } from 'react-router-dom';

const LINKS = [
  { to: '/', label: 'Dashboard', Icon: DashboardIcon, end: true },
  { to: '/withdrawals', label: 'Withdrawals', Icon: WithdrawIcon },
  { to: '/integrations', label: 'Integrations', Icon: IntegrationsIcon },
];

export default function NavBar({ user }) {
  const location = useLocation();

  return (
    <AppBar position="static" color="default" elevation={1} sx={{ mb: 3 }}>
      <Toolbar>
        <Typography variant="h6" sx={{ flexShrink: 0, fontWeight: 700, mr: 4 }}>
          Nebula HQ
        </Typography>
        <Box sx={{ display: 'flex', gap: 1, flexGrow: 1 }}>
          {LINKS.map(({ to, label, Icon, end }) => {
            const active = end ? location.pathname === '/' : location.pathname.startsWith(to);
            return (
              <Button
                key={to}
                component={NavLink}
                to={to}
                color={active ? 'primary' : 'inherit'}
                variant={active ? 'contained' : 'text'}
                startIcon={<Icon />}
              >
                {label}
              </Button>
            );
          })}
        </Box>
        {user ? (
          <Chip
            avatar={<Avatar>{user.email?.[0]?.toUpperCase() || 'U'}</Avatar>}
            label={user.email || user.role || 'User'}
            variant="outlined"
          />
        ) : (
          <Chip label="Guest" variant="outlined" />
        )}
      </Toolbar>
    </AppBar>
  );
}
